import { render, staticRenderFns } from "./FlatFlyerPricing.vue?vue&type=template&id=7bffa89d"
import script from "./FlatFlyerPricing.vue?vue&type=script&lang=js"
export * from "./FlatFlyerPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports